import { createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";

const initialState = {
  ...initialStateSlice,
  body: {
    isOpen: false,
  },
};

const modalUploadLogoSlice = createSlice({
  name: "modal/uploadLogo",
  initialState,
  reducers: {
    set_modalUploadLogo: (state, action) => {
      return action.payload;
    },
    onOpenModalUploadLogo: (state) => {
      state.body.isOpen = true;
    },
    onCloseModalUploadLogo: (state) => {
      state.body.isOpen = false;
    },
  },
});

export const {
  set_modalUploadLogo,
  onOpenModalUploadLogo,
  onCloseModalUploadLogo,
} = modalUploadLogoSlice.actions;

export default modalUploadLogoSlice;
